export const hereApiKey = "t8e8zEKiMnZdgqzf0qNeMbiqSPAVQHUp5MSi-9Wgoe0";

